import { API } from 'aws-amplify';
import moment from 'moment';

const sendData = async ({ data, geolocation }) => {
  if (Object.keys(data).length) {
    const deviceInfo = {
      navegador: window.navigator.userAgent,
      appVersion: window.navigator.appVersion,
      platform: window.navigator.platform,
      vendor: window.navigator.vendor,
      locationRef: window.location.href,
      geolocation
    };
    const { appData: { name } } = data;
    const [assetId] = data.data.map(({ assetId }) => assetId);
    const coordinates = geolocation !== undefined ? [geolocation.longitude, geolocation.latitude, 0] : [];
    const trackingInfo = {
      assetId,
      appName: name,
      deviceInfo,
      coordinates,
      createdAt: moment().utc()
    };
    await API.post('tracking', '/tracking', {
      body: trackingInfo
    });
  }
};

const successApiGeo = async ({ position, data }) => {
  const geolocation = {};
  const { coords } = position;
  geolocation.latitude = coords.latitude;
  geolocation.longitude = coords.longitude;
  await sendData({ data, geolocation });
};

const errorCallbackApiGeo = async ({ error, data }) => {
  console.error(error.message);
  await sendData({ data });
};
const trackingUserInfo = async ({ data }) => {
  const geolocationAPI = navigator.geolocation;
  try {
    geolocationAPI.getCurrentPosition((position) => successApiGeo({ position, data }), (error) => errorCallbackApiGeo({ error, data }));
  } catch (error) {
    console.error(error);
    await sendData({ data });
  }
};

export default trackingUserInfo;
